
import React from 'react';
import { Button } from '@/components/ui/button';

interface FilterButtonsProps {
  onReset: () => void;
  onApply?: () => void;
  showApplyButton?: boolean;
}

export const FilterButtons: React.FC<FilterButtonsProps> = ({ 
  onReset, 
  onApply,
  showApplyButton = true
}) => {
  return (
    <div className="flex space-x-2 w-full">
      <Button 
        variant="outline" 
        onClick={onReset}
        size="sm"
        className={!showApplyButton ? "w-full" : ""}
      >
        Reset
      </Button>
      
      {showApplyButton && onApply && (
        <Button 
          onClick={onApply}
          size="sm"
        >
          Apply
        </Button>
      )}
    </div>
  );
};
